import {
  KSendSuccessResponse,
  TableRowDto,
} from '@asset-metrix/portal-gateway-client-js';
import { MutationFunction } from '@tanstack/react-query';

import { extractErrorMessage } from '../../utils/errorMessage';
import { HttpError } from '../../utils/errors';
import { portalGatewayClient } from '../portalGatewayClient';

export const updateTableRow: MutationFunction<
  KSendSuccessResponse,
  {
    contentId: string;
    rowId: string;
    data: TableRowDto;
  }
> = async ({ contentId, rowId, data }) => {
  const response = await portalGatewayClient.table.putTableRowData(
    contentId,
    rowId,
    data
  );

  if (!response.ok) {
    throw new HttpError(
      extractErrorMessage(response.error, `Error updateting row ${rowId}`),
      response.status
    );
  }

  return response.data;
};
